import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowLeftRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-left-right, sort 2, switch horizonatl"><path d="M7.75 20.75L3.75 16.75L7.75 12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16.25 11.25L20.25 7.25L16.25 3.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5 16.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 7.25H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowLeftRight;
